import { createDiv, createDom, makeClickable, removeDom } from "../domUtils.mjs";
import { VirtualContext } from "../VirtualContext.mjs";
import mockConfig from "./config.mjs";
import createError from "./createError.mjs";
const open = function() {
  return new Promise(function(resolve, reject) {
    const groups = mockConfig.group;
    const overlay = createDiv("devkit-instant-mock-overlay");
    const container = createDiv(
      "devkit-instant-mock-matchmakingSearch",
      overlay
    );
    const box = createDiv(
      "devkit-instant-mock-matchmakingSearch-box",
      container
    );
    const closeButton = createDiv("devkit-instant-mock-closeBtn", box);
    createDom("h1", null, box).innerText = "Searching ...";
    makeClickable(closeButton, () => {
      removeDom(overlay);
      reject(createError("USER_INPUT"));
    });
    const contexts = Object.keys(groups);
    const contextId = contexts[Math.floor(Math.random() * contexts.length)];
    const playersIds = groups[contextId].players;
    const players = playersIds.map((id) => {
      return mockConfig.player[id];
    });
    const context = VirtualContext.group(players, contextId);
    setTimeout(() => {
      removeDom(overlay);
      resolve(context);
    }, 2e3);
  });
};
const matchmakingSearch = { open };
export {
  matchmakingSearch as default
};
